import { render, staticRenderFns } from "./room-selector.vue?vue&type=template&id=63780ac6&scoped=true"
import script from "./room-selector.vue?vue&type=script&lang=js"
export * from "./room-selector.vue?vue&type=script&lang=js"
import style0 from "./room-selector.vue?vue&type=style&index=0&id=63780ac6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63780ac6",
  null
  
)

export default component.exports